import { Box, Button, Divider, TextField } from "@mui/material"
import { useCallback, useMemo, useState } from "react"

import { MasterDialog } from "#common/Dialog/Dialog"
import { InputSelect } from "#common/input/InputSelect"
import { useApiSend } from "#hooks/useApiSend"
import { INTERACTIONS } from "#job-profile/constants"
import { jobProfileInteractionsPost } from "#job-profile/services/api"
import { toast } from "react-toastify"
import { JobProfileInteractionTable } from "./JobProfileInteractionTable"

const INTERACTION_DEFAULT = {
	con_quien: "",
	para_que: "",
}

export default function JobProfileInteractionForm({ value, setValue }) {
	const fields = (name) => {
		return {
			key: name,
			value: value[name],
			onChange: (event) => setValue({ ...value, [name]: event.target.value }),
		}
	}
	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} width={"100%"}>
			<InputSelect
				data={INTERACTIONS.map((item) => {
					return {
						name: item,
					}
				})}
				label="Tipo"
				{...fields("tipo")}
				dataId="name"
				dataLabel="name"
			/>
			<TextField label="¿Con quien?" fullWidth {...fields("con_quien")} />
			<TextField
				label="¿Para qué?"
				fullWidth
				{...fields("para_que")}
				multiline
				rows={2}
			/>
		</Box>
	)
}

const interactionValidation = (interaction) => {
	if (!interaction.con_quien) {
		toast.error("El con quien es requerido")
		return
	}
	if (!interaction.para_que) {
		toast.error("La para qué es requerido")
		return
	}
	return true
}

export const JobProfileInteractionFormList = ({ value, setValue }) => {
	const [interaction, setInteraction] = useState(INTERACTION_DEFAULT)
	const handleSave = () => {
		if (!interactionValidation(interaction)) return

		setValue((old) => [...old, interaction])
		setInteraction(INTERACTION_DEFAULT)
	}
	const handleDelete = (datum) => {
		setValue(value.filter((item) => item.con_quien !== datum.con_quien))
	}
	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"}>
			<JobProfileInteractionForm value={interaction} setValue={setInteraction} />
			<Button onClick={handleSave}>Agregar</Button>
			<Divider sx={{ width: "100%" }} />
			<JobProfileInteractionTable data={value || []} onDelete={handleDelete} />
		</Box>
	)
}

export const JobProfileInteractionFormDialog = ({
	open,
	setOpen,
	profileId,
	refresh,
}) => {
	const [interaction, setInteractions] = useState(INTERACTION_DEFAULT)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		setInteractions(INTERACTION_DEFAULT)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(jobProfileInteractionsPost, { success, end })

	const handleSend = useCallback(() => {
		if (!interactionValidation(interaction)) return
		setDisabled(true)
		fetch(profileId, interaction)
	}, [fetch, profileId, interaction])

	const handleClose = useCallback(() => {
		setOpen(false)
		setInteractions(INTERACTION_DEFAULT)
	}, [setOpen])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handleClose,
				disabled,
			},
			{
				label: "Agregar",
				onClick: handleSend,
				disabled,
			},
		],
		[disabled, handleClose, handleSend]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: "Agregar relaciones internos y/o externas",
				buttons,
				maxWidth: "md",
				closeDialog: handleClose,
			}}
		>
			<JobProfileInteractionForm value={interaction} setValue={setInteractions} />
		</MasterDialog>
	)
}
